import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Container, Box, CircularProgress, Typography } from '@mui/material';

const PaymentSuccessPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    
    if (sessionId) {
      // Redirect to confirmation page with success parameters
      navigate(`/confirmation?success=true&session_id=${sessionId}`, { replace: true });
    } else {
      // No session ID, redirect to home
      navigate('/', { replace: true });
    }
  }, [navigate, searchParams]);

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '50vh',
        flexDirection: 'column' 
      }}>
        <CircularProgress size={48} sx={{ mb: 2 }} />
        <Typography variant="h6" sx={{ mb: 1 }}>
          Processing your booking...
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Please wait while we confirm your payment
        </Typography>
      </Box>
    </Container>
  );
};

export default PaymentSuccessPage;